"use strict";

import {
  loadingSelectArray,
  debitCardTypes,
  commonConstants,
  onboardingConstants,
} from "../_redux/_constants";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { useEffect, useRef } from "react";
import moment from "moment";
import creditCardType from "credit-card-type";
import * as uuid from "uuid";
import { keyGenerationRequest } from "../_redux/_actions";
import i18n from "i18next";
import ExcelImg from "../styles/img/excel.png";
import PdfImg from "../styles/img/pdf.png";
import Img from "../styles/img/img.png";
import WordImg from "../styles/img/word.png";
import { secureEmailConstants } from "../_redux/_constants";

const isShowMainLoading = (subSetArray) => {
  return subSetArray.some((value) => {
    return loadingSelectArray.includes(value);
  });
};

const isShowGridDataLoading = (pendingListArray, value) => {
  if (pendingListArray.length === 0) {
    return false;
  }

  return pendingListArray.includes(value);
};

const showCustomLoading = (subSetArray, pendingListArray) => {
  if (!Array.isArray(subSetArray)) {
    return false;
  }

  if (Array.isArray(pendingListArray) && pendingListArray.length === 0) {
    return false;
  }

  return pendingListArray?.some((value) => {
    return subSetArray.includes(value);
  });
};

const isErrorCodeExist = (errorCodes, customErrorList) => {
  if (customErrorList?.length === 0) {
    return false;
  }

  return (
    customErrorList?.filter((el) => {
      return errorCodes.some((f) => {
        return f == el.statusCode;
      });
    }).length > 0
  );
};

const selectCustomError = (errorCode, customErrorList) => {
  if (customErrorList?.length === 0) {
    return false;
  }

  return customErrorList?.filter((error) => error.statusCode == errorCode)[0];
};

Number.prototype.format = function (n, x, s, c) {
  var re = "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\D" : "$") + ")",
    num = this.toFixed(Math.max(0, ~~n));
  return (c ? num.replace(".", c) : num).replace(
    new RegExp(re, "g"),
    "$&" + (s || ""),
  );
};

const amountFormat = (amount, n, x, s, c) => {
  return amount.format(n, x, s, c);
};

const numberWithCommas = (amount) => {
  return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const getAmountAndCents = (amount, type) => {
  if (typeof amount != "undefined") {
    let floatAmount = amount.toFixed(2);
    if (type == "amount") {
      return parseInt(floatAmount);
    } else {
      let cent = /\.(\d{2})/.exec(floatAmount)[1];
      return cent;
    }
  } else {
    return null;
  }
};

const setBrowserUuid = () => {
  localStorage.setItem("uuid", uuid.v4());
};

const getBrowserUuid = () => {
  if (
    localStorage.getItem("uuid") != undefined ||
    localStorage.getItem("uuid") != null
  )
    return localStorage.getItem("uuid");
  else return null;
};

const getFingerPrint = async () => {
  // To prevent fingerprint change for same window
  if (
    localStorage.getItem("fingerPrint") == undefined ||
    localStorage.getItem("fingerPrint") == null
  ) {
    const fpPromise = FingerprintJS.load();
    const fp = await fpPromise;
    const result = await fp.get();
    if (getBrowserUuid() == null) setBrowserUuid();

    const fingerPrint = result.visitorId + "_" + getBrowserUuid();
    localStorage.setItem("fingerPrint", fingerPrint);
    return fingerPrint;
  } else {
    return localStorage.getItem("fingerPrint");
  }
};

const keyGenerationFun = async (actionDispatch, generate = false) => {
  const fingetPrint = await getFingerPrint();
  const request = {
    uid: fingetPrint,
    generate: generate,
  };
  actionDispatch(keyGenerationRequest(request));
};

const previousProps = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

const formatDate = (date) => {
  let formatedDate = moment(date).format("ll");
  return formatedDate;
};

const formatTime = (dateTime) => {
  const formattedTime = moment(dateTime, "YYYY-MM-DD HH:mm:ss").format(
    "h:mm A",
  );

  return formattedTime;
};

const formatMobileNumber = (mobile) => {
  let formatedNumber = mobile.replace(/\s/g, "");
  if (formatedNumber.charAt(0) == "0") {
    formatedNumber = formatedNumber.replace(/^./g, "+94");
  } else if (formatedNumber.substring(0, 3) == "+94" || mobile == "") {
    return formatedNumber;
  } else {
    formatedNumber = "+94".concat(formatedNumber);
  }
  return formatedNumber;
};

const getCardType = (number) => {
  // visa
  let re = new RegExp("^4");
  if (number.match(re) != null) return debitCardTypes.CARD_TYPE_VISA;

  let v1 = new RegExp("^5");
  if (number.match(v1) != null) return debitCardTypes.CARD_TYPE_MASTERCARD;

  let v2 = new RegExp("^2");
  if (number.match(v2) != null) return debitCardTypes.CARD_TYPE_MASTERCARD;

  // Mastercard
  // Updated for Mastercard 2017 BINs expansion
  if (
    /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(
      number,
    )
  )
    return debitCardTypes.CARD_TYPE_MASTERCARD;

  // AMEX
  re = new RegExp("^3[47]");
  if (number.match(re) != null) return debitCardTypes.CARD_TYPE_AMEX;

  // Discover
  re = new RegExp(
    "^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)",
  );
  if (number.match(re) != null) return debitCardTypes.CARD_TYPE_DISCOVER;

  // Diners
  re = new RegExp("^36");
  if (number.match(re) != null) return debitCardTypes.CARD_TYPE_DINERS;

  // Diners - Carte Blanche
  re = new RegExp("^30[0-5]");
  if (number.match(re) != null) return "Diners - Carte Blanche";

  // JCB
  re = new RegExp("^35(2[89]|[3-8][0-9])");
  if (number.match(re) != null) return "JCB";

  // Visa Electron
  re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
  if (number.match(re) != null) return "Visa Electron";

  return "";
};

const isIncreasingSequence = (value) => {
  if (typeof value == "undefined") {
    return true;
  }

  let numbers = [...value];

  if (numbers.length < 6) {
    return true;
  }

  for (let num = 0; num < numbers.length - 1; num++) {
    if (!(numbers[num] < numbers[num + 1])) {
      return false;
    }
  }

  return true;
};

const checkStringLength = (str, length) => {
  if (typeof str == "undefined") {
    return false;
  }

  return str.length > length - 1;
};

const checkCharactorsAndStringContain = (str) => {
  if (typeof str == "undefined") {
    return false;
  }

  return /\d/.test(str) && /[a-zA-Z]/g.test(str);
};

const passcodeCheckDigitMoreThanTwice = (value) => {
  if (typeof value == "undefined") {
    return true;
  }

  let returnValue = false;

  const charData = [...value];

  if (charData.length < 6) {
    return true;
  }

  for (let index = 0; index < charData.length; index++) {
    const element = charData[index];
    if (!returnValue) {
      if (value.split(element).length - 1 > 2) {
        returnValue = true;
        break;
      }
    }
  }

  return returnValue;
};

function getCreditCardType(accountNumber) {
  let result = null;
  let cardType = creditCardType(accountNumber.toString());
  if (cardType.length == 1) {
    result = cardType[0].type ? cardType[0].type : "other";
  } else {
    result = "other";
  }

  return result;
}

function cardNumberFormat(num) {
  if (typeof num == "undefined") {
    return "";
  }

  return `${num.substr(0, 4)} ${"*".repeat((num.length - 8) / 2)} ${"*".repeat(
    (num.length - 8) / 2,
  )} ${num.substr(num.length - 4)}`;
}

const numberFormat = (number, previousNumber, numberMaxLenght = 9) => {
  const regex = new RegExp(
    `^(0(\\.\\d{0,2})?|([1-9]\\d{0,${numberMaxLenght}})(\\.\\d{0,2})?)$`,
  );
  const regexMatch = regex.test(number);

  if (!regexMatch) {
    return previousNumber;
  } else {
    if (number.search(/\./g) >= 0) {
      let amountSplit = number.split(".");

      return `${amountFormat(parseFloat(amountSplit[0]), 0, 3, ",", "")}.${
        amountSplit[1]
      }`;
    } else {
      return amountFormat(parseFloat(number), 0, 3, ",", "");
    }
  }
};

//Luhn algorithm in Javascript. Check valid credit card numbers
/* 
function validCreditCard(value) {
    // Accept only digits, dashes or spaces
    if (/[^0-9-\s]+/.test(value)) return false;

    // The Luhn Algorithm. It's so pretty.
    let nCheck = 0;
    value = value.replace(/\D/g, "");

    for (let n = 0; n < value.length; n++) {
        let nDigit = parseInt(value[n], 10);

        if (!(n % 2) && (nDigit *= 2) > 9) nDigit -= 9;

        nCheck += nDigit;
    }

    return (nCheck !== 0) && (nCheck % 10) == 0
} */

const passwordValidateForBothNumericAndAlphabetic = (password) => {
  const regex =
    /^(?=[a-zA-Z0-9 !#$%&*+,-?@^_~]*[A-Za-z])(?=[a-zA-Z0-9 !#$%&*+,-?@^_~]*[0-9])[a-zA-Z0-9 !#$%&*+,-?@^_~]{2,20}$/;
  return regex.test(password);
};

const passwordValidatePolicy = (password) => {
  const regex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!#$%&*()@^+=\-])[A-Za-z\d!#$%&*()@^+=\-]{8,32}$/;
  return regex.test(password);
};

const specialCharactersCheck = (password) => {
  const regex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!#$%&*()@^+=\-])[A-Za-z\d!#$%&*()@^+=\-]+$/;
  return regex.test(password);
};

// returns true or false
function validCreditCard(cardNumber) {
  cardNumber = cardNumber.split(" ").join("");
  if (
    parseInt(cardNumber) <= 0 ||
    !/\d{15,16}(~\W[a-zA-Z])*$/.test(cardNumber) ||
    cardNumber.length > 16
  ) {
    return false;
  }
  var carray = new Array();
  for (var i = 0; i < cardNumber.length; i++) {
    carray[carray.length] = cardNumber.charCodeAt(i) - 48;
  }
  carray.reverse();
  var sum = 0;
  for (var j = 0; j < carray.length; j++) {
    var tmp = carray[j];
    if (j % 2 != 0) {
      tmp *= 2;
      if (tmp > 9) {
        tmp -= 9;
      }
    }
    sum += tmp;
  }
  return sum % 10 == 0;
}

const camelize = (str) => {
  return str != null && str.length > 0
    ? str.toLowerCase().charAt(0).toUpperCase() + str.slice(1).toLowerCase()
    : null;
};

const formatNicNumberInput = (value) => {
  const nicNumber = value.replace(/[^0-9VXvx]/g, "").slice(0, 12);
  const isValid = /^\d{12}$|^\d{9}[VXvx]$/.test(nicNumber);

  return {
    value: nicNumber,
    isValid,
    message: isValid ? "" : i18n.t("Please enter a valid NIC number"),
  };
};

const formatCanNumberInput = (value) => {
  const canNumber = value.replace(/[^0-9]/g, "").slice(0, 12);
  const isValid = /^[0-9]{12}$/.test(canNumber);

  return {
    value: canNumber,
    isValid,
    message: isValid ? "" : i18n.t("Only numbers are allowed."),
  };
};

const formatAccountNumber = (value) => {
  const accountNumber = value.replace(/[^0-9]/g, "");
  const isValid = /^[0-9]{10,12}$/.test(accountNumber);

  if (isValid) {
    return accountNumber;
  }
  if (accountNumber.length > 12) {
    return accountNumber.slice(0, 12);
  }
  return {
    isValid,
    message: isValid ? "" : i18n.t("Only numbers are allowed."),
  };
};

const getOnboardingAccountNumberPattern = (accountType) => {
  const maxLength = onboardingConstants.ONBOARDING_ACCOUNT_NUMBER_MAX_LENGTH;

  if (accountType === onboardingConstants.REGISTRATION_OPTION_LENDING) {
    const minLength = onboardingConstants.ONBOARDING_LENDING_ACCOUNT_MIN_LENGTH;
    return new RegExp(`^[A-Z0-9-]{${minLength},${maxLength}}$`);
  }

  const minLength =
    accountType === onboardingConstants.REGISTRATION_OPTION_FIXED_DEPOSITS
      ? onboardingConstants.ONBOARDING_FD_ACCOUNT_MIN_LENGTH
      : onboardingConstants.ONBOARDING_NUMERIC_ACCOUNT_MIN_LENGTH;

  return new RegExp(`^[0-9]{${minLength},${maxLength}}$`);
};

const formatOnboardingAccountNumberInput = (value, accountType) => {
  const raw = value ?? "";
  const maxLength = onboardingConstants.ONBOARDING_ACCOUNT_NUMBER_MAX_LENGTH;
  const isLending =
    accountType === onboardingConstants.REGISTRATION_OPTION_LENDING;
  const accountNumber = isLending
    ? raw
        .replace(/[^0-9A-Za-z-]/g, "")
        .toUpperCase()
        .slice(0, maxLength)
    : raw.replace(/[^0-9]/g, "").slice(0, maxLength);
  const isValid = getOnboardingAccountNumberPattern(accountType).test(
    accountNumber,
  );

  return {
    value: accountNumber,
    isValid,
    message: isValid
      ? ""
      : i18n.t(
          isLending
            ? "Please enter a valid account number."
            : "Only numbers are allowed.",
        ),
  };
};

const isOnboardingAccountNumberValid = (value, accountType) =>
  formatOnboardingAccountNumberInput(value, accountType).isValid;
const validPassportNumber = (value) => {
  const passportNumber = value.replace(/[^0-9A-Za-z]/g, "");
  const isValid = /^[A-Za-z0-9]{6,12}$/.test(passportNumber);

  return {
    isValid,
    message: isValid ? "" : i18n.t("Please enter a valid passport number."),
  };
};

const formatBytesToKB = (size) => {
  if (!size || isNaN(size)) return "(0KB)";
  const kb = Math.round(size / 1024);
  return `(${kb.toLocaleString()}KB)`;
};

const STATEMENT_SUCCESS_CODE = "00";

const isJsonContentType = (contentType = "") =>
  contentType.toLowerCase().includes("application/json");

const parseJsonEnvelope = (parsed) => parsed?.response ?? parsed ?? {};

const isStatementFailure = (envelope) =>
  envelope?.status === "failure" ||
  (envelope?.responseCode != null &&
    envelope.responseCode !== STATEMENT_SUCCESS_CODE);

const parseBlobAsJson = async (blob) => {
  const text = await blob.text();
  return JSON.parse(text);
};

const getResponseContentType = (xhr, blob) =>
  xhr?.getResponseHeader?.("content-type") || blob?.type || "";

const buildStatementDownloadError = (statusCode, message) => ({
  response: {
    statusCode: statusCode ?? "01",
    message:
      message ?? "Something is technically wrong. Please try again later.",
  },
});

const parseStatementJsonFailure = async (blob, contentType) => {
  if (!isJsonContentType(contentType) && blob?.type !== "application/json") {
    return null;
  }

  const parsed = await parseBlobAsJson(blob);
  const envelope = parseJsonEnvelope(parsed);

  if (!isStatementFailure(envelope)) {
    return null;
  }

  return buildStatementDownloadError(
    envelope.responseCode,
    envelope.message,
  );
};

const normalizeStatementDownloadError = async (error) => {
  if (error?.response?.statusCode != null && error?.response?.message != null) {
    return error;
  }

  const xhr = error?.xhr;
  const response = error?.response;
  const contentType =
    xhr?.getResponseHeader?.("content-type") ||
    response?.type ||
    "";

  if (response && typeof response.text === "function") {
    try {
      const parsed = await parseBlobAsJson(response);
      const envelope = parseJsonEnvelope(parsed);

      if (envelope?.responseCode != null || envelope?.status != null) {
        return buildStatementDownloadError(
          envelope.responseCode ?? error?.status,
          envelope.message,
        );
      }

      if (parsed?.statusCode != null || parsed?.message != null) {
        return buildStatementDownloadError(parsed.statusCode, parsed.message);
      }
    } catch {
      // fall through to default error shape
    }
  }

  if (response && typeof response === "object" && !response.text) {
    if (response.statusCode != null || response.message != null) {
      return buildStatementDownloadError(response.statusCode, response.message);
    }

    const envelope = parseJsonEnvelope(response);
    if (envelope?.responseCode != null || envelope?.status != null) {
      return buildStatementDownloadError(
        envelope.responseCode ?? error?.status,
        envelope.message,
      );
    }
  }

  return buildStatementDownloadError(
    error?.status,
    error?.message || error?.response?.message,
  );
};

const downloadBlobFile = (fileName, data) => {
  const blob = new Blob([data], {
    type: data.type || "application/octet-stream",
  });

  const fileURL = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = fileURL;

  const filename =
    fileName && typeof fileName === "string" ? fileName : "DownloadFile";

  link.download = filename;

  document.body.appendChild(link);
  link.click();

  setTimeout(() => {
    URL.revokeObjectURL(fileURL);
    link.remove();
  }, 100);
};

const getFileIcon = (iconType) => {
  const {
    UPLOAD_FILE_TYPE_PDF,
    UPLOAD_FILE_TYPE_JPEG,
    UPLOAD_FILE_TYPE_JPG,
    UPLOAD_FILE_TYPE_PNG,
    UPLOAD_FILE_TYPE_PNG_CAP,
    UPLOAD_FILE_TYPE_WORD,
    UPLOAD_FILE_TYPE_DOC,
    UPLOAD_FILE_TYPE_XLS,
    UPLOAD_FILE_TYPE_XLSX,
  } = secureEmailConstants;

  switch (iconType) {
    case UPLOAD_FILE_TYPE_PDF:
      return PdfImg;
    case UPLOAD_FILE_TYPE_JPEG:
    case UPLOAD_FILE_TYPE_JPG:
    case UPLOAD_FILE_TYPE_PNG:
    case UPLOAD_FILE_TYPE_PNG_CAP:
      return Img;
    case UPLOAD_FILE_TYPE_WORD:
    case UPLOAD_FILE_TYPE_DOC:
      return WordImg;
    case UPLOAD_FILE_TYPE_XLS:
    case UPLOAD_FILE_TYPE_XLSX:
      return ExcelImg;
    default:
      return Img;
  }
};

const getCurrentFormattedDateTime = () => {
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(now.getDate()).padStart(2, "0");

  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

const getMaskedPoliceMobile = (mobile) => {
  if (!mobile || typeof mobile !== "string") return "";
  const digitsOnly = mobile.replace(/\D/g, "");
  if (digitsOnly.length <= 4) return digitsOnly;

  const firstPart = digitsOnly.slice(0, 3);
  const lastPart = digitsOnly.slice(-3);
  return `${firstPart}****${lastPart}`;
};

const truncateTextWithEllipsis = (text, maxLength) => {
  const value = text != null ? String(text) : "";
  return value.length > maxLength
    ? `${value.slice(0, maxLength)}...`
    : value;
};

export {
  isShowMainLoading,
  isShowGridDataLoading,
  showCustomLoading,
  isErrorCodeExist,
  selectCustomError,
  amountFormat,
  numberWithCommas,
  getFingerPrint,
  formatDate,
  previousProps,
  getAmountAndCents,
  formatMobileNumber,
  getCardType,
  isIncreasingSequence,
  passcodeCheckDigitMoreThanTwice,
  getCreditCardType,
  cardNumberFormat,
  numberFormat,
  validCreditCard,
  passwordValidateForBothNumericAndAlphabetic,
  checkStringLength,
  checkCharactorsAndStringContain,
  camelize,
  formatTime,
  keyGenerationFun,
  passwordValidatePolicy,
  formatNicNumberInput,
  formatCanNumberInput,
  formatAccountNumber,
  formatOnboardingAccountNumberInput,
  getOnboardingAccountNumberPattern,
  isOnboardingAccountNumberValid,
  validPassportNumber,
  specialCharactersCheck,
  getFileIcon,
  formatBytesToKB,
  downloadBlobFile,
  getCurrentFormattedDateTime,
  isJsonContentType,
  parseBlobAsJson,
  getResponseContentType,
  parseStatementJsonFailure,
  normalizeStatementDownloadError,
  getMaskedPoliceMobile,
  truncateTextWithEllipsis
};
